import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { UserPreferencesPayload } from '../utils/user/userPreferences.service';

interface UserPreferencesState {
  modelPref: string | null;
  fontSize: string | null;
  bubbleColor: string | null;
  followUpQuestions: boolean;
  isLoading: boolean;
  hasFetched: boolean;
}

const FOLLOW_UP_STORAGE_KEY = 'user-pref-follow-up-questions';

const initialState: UserPreferencesState = {
  modelPref: null,
  fontSize: null,
  bubbleColor: null,
  followUpQuestions: localStorage.getItem(FOLLOW_UP_STORAGE_KEY) !== 'false',
  isLoading: false,
  hasFetched: false,
};

const userPreferencesSlice = createSlice({
  name: 'userPreferences',
  initialState,
  reducers: {
    setPrefsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },
    setUserPreferences(state, action: PayloadAction<Pick<UserPreferencesPayload, 'modelPref' | 'fontSize' | 'bubbleColor' | 'followUpQuestions'>>) {
      if (action.payload.modelPref !== undefined) {
        state.modelPref = action.payload.modelPref;
      }
      if (action.payload.fontSize !== undefined) {
        state.fontSize = action.payload.fontSize;
      }
      if (action.payload.bubbleColor !== undefined) {
        state.bubbleColor = action.payload.bubbleColor;
      }
      if (action.payload.followUpQuestions !== undefined) {
        state.followUpQuestions = action.payload.followUpQuestions;
        try {
          localStorage.setItem(FOLLOW_UP_STORAGE_KEY, String(action.payload.followUpQuestions));
        } catch {
          // Ignore storage write errors (e.g., disabled storage / quota exceeded)
        }
      }
      state.hasFetched = true;
      state.isLoading = false;
    },
  },
});

export const { setPrefsLoading, setUserPreferences } = userPreferencesSlice.actions;
export default userPreferencesSlice.reducer;
